
import Deferred from '~/deferred';

export default class FacilitiesService {

  constructor () {
    const deferred = new Deferred();
    this.deferred = { providerReady: deferred };
    this.lock = { providerReady: deferred.promise };
    // ['providerReady'].map(Deferred.addLock(this));
  }

  setProvider (provider) {
    this.provider = provider;
    this.deferred.providerReady.resolve(provider);
  }

  async getProvider () {
    const provider = await this.lock.providerReady;
    return provider;
  }

  // getClosest :: () -> Promise [Facility]
  async getClosest () {
    return this.lock.providerReady
      .then(provider =>
        provider.getClosest()
          .catch(e => {
            console.error(e);
            return [];
          })
      );
  }

  getFacility (id) {
    return this.provider.getFacility(id);
  }
}

export function getFacilityService () {
  return new FacilitiesService();
}
